import React, { Component } from 'react';
import i from '../imports';


class Gallery extends Component {

    NextArrow(props) {
        const { className, style, onClick } = props;
        return (
          <div
            className={className}
            style={{ ...style,  color: "#FFFFFF",  right: '10px', zIndex: 1 }}
            onClick={onClick}
          ><i.Icon icon={i.faIcons.chevronRight} className="gallery-nav-icon"/></div>
        );
      }
      
      PrevArrow(props) {
        const { className, style, onClick } = props;
        return (
          <div
            className={className}
            style={{ ...style,  color: "#FFFFFF", left: '10px', zIndex: 1 }}
            onClick={onClick}
            ><i.Icon icon={i.faIcons.chevronLeft} className="gallery-nav-icon"/></div>
        );
      }

      renderSlide(img){
          return(
        <i.PureGridProvider >
            <i.Container style={{ backgroundColor: "#AAAAAA", paddingBottom:'56.75%', backgroundImage: `url(${img})`, backgroundSize: "cover", backgroundPosition: "50% 50%" }}>
                <i.Row >
                    <i.Col >
                    </i.Col>
                </i.Row>
            </i.Container>
        </i.PureGridProvider>)
      }

    render() {

        if (this.props.images === undefined || this.props.images.length < 1)
            return null;
      

        return (
            <i.SlickSlider
                autoplay={true}
                wrapAround={true}
                arrows={true}
                dots={false}
                nextArrow={<this.NextArrow />}
                prevArrow={<this.PrevArrow />}
            >
                {this.props.images.map(m => this.renderSlide(m))}
            </i.SlickSlider>
        );
    }
}

export default Gallery;